import React from 'react'
import { reduxForm, Field } from 'redux-form'

import { Checkbox, Notification } from '@offerzen/pinata'

import { previousOnboardingUrl } from '../../helpers/onboardingSteps'
import CardFooterNav from '../CardFooterNav/CardFooterNav'

import styles from './styles'

const NoWorkExperienceForm = props => (
  <form onSubmit={props.handleSubmit}>
    <If condition={!props.workRecordsAdded && !props.isAddingNewRecord}>
      <Field
        theme="primary"
        className={styles.workExperience}
        name="no_work_history"
        id="no-work-history"
        label="I don’t have any work experience yet"
        component={Checkbox}
        checked={false}
      />
    </If>

    <If condition={props.error}>
      <Notification theme="error" className={styles.notice}>
        {props.error}
      </Notification>
    </If>

    <CardFooterNav
      navigateBack={() => props.history.push(previousOnboardingUrl(props.location.pathname))}
      loading={props.submitting}
      className={styles.footer}
      theme="primary"
    />
  </form>
)

export default reduxForm({
  form: 'noWorkExperienceForm',
  onChange: (_, __, props) => props.clearErrors(),
  onSubmit: (values, _, props) => new Promise((resolve, reject) => props.submitWorkExperience(values, resolve, reject)),
})(NoWorkExperienceForm)
